import { render, staticRenderFns } from "./EipDemensionDialog.vue?vue&type=template&id=38864dbf&"
import script from "./EipDemensionDialog.vue?vue&type=script&lang=js&"
export * from "./EipDemensionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports